import constants from '../services/constants';
import { atom } from 'recoil';

const deletedTeamRoleAtom = atom<{roleId: string, role:string} | null>({
    key: constants.deletedTeamRoleAtom,
    default: null,
});

export default deletedTeamRoleAtom;